import {Box, styled} from '@mui/material';
import {Color} from '~/constants/style';

export const Main = styled(Box)(() => ({
  maxHeight: '100vh',
  overflow: 'auto',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: Color.SidebarMain,
}));

export const Content = styled(Box)(() => ({
  padding: '16px 24px 36px',
}));

export const VerticalDivider = styled(Box)(() => ({
  borderRightWidth: '1px',
  borderRightStyle: 'solid',
  borderRightColor: '#EAECF0',
}));

export const SaveInvoiceButtonWrapperStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  margin: '16px 0 0 0',
  padding: '0 16px',
};

export const SaveInvoiceButtonStyles = {
  borderRadius: '8px',
};

export const InvoiceDetailsContentWrapperStyles = {
  display: 'flex',
  flexDirection: 'row',
  gap: 2,
};

export const InvoiceDetailsStyles = {
  width: '50%',
  height: '100%',
  padding: 2,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

export const LoadingWrapperStyles = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const InfoFieldValueStyles = {
  minWidth: '180px',
  background: '#fff',
  borderRadius: 2,
  px: 2,
  py: 1.5,
  boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
};

export const noItemsPresentTextStyles = {
  color: Color.Grey400,
  fontSize: '8px',
};

export const patientDetailsBoxStyles = {
  padding: 2,
  height: '100%',
};

export const invoiceMetaBoxStyles = {
  padding: 2,
  height: '100%',
};

export const itemsToBillBoxStyles = {
  padding: 2,
  height: '100%',
};

export const invoiceTitleStyles = {
  color: Color.Purple600,
};

export const itemsToBillItemBoxStyles = {
  display: 'flex',
  gap: 2,
  alignItems: 'center',
  flexWrap: 'wrap',
};
